import React from "react";

export function LoaderIcone() {
  return (
    <div className="spinner-border spinner-border-sm text-light ms-3" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );
}

export function LoginLoaderIcone() {
  return (
    <div className="spinner-border spinner-border-sm text-danger ms-3" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );
}